(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ProductSearch', ProductSearch);

  ProductSearch.$inject = ['$resource', 'API_URI'];

  function ProductSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
